import * as React from 'react';

import { IDocument, IPostcardImage } from '../../infrastructure/interfaces';
import Radio from '../Radio';

export interface IPostcardImageFrontEditorFormProps {
  document: IDocument;
  postcardImagesList: IPostcardImage[];
  onPostcardImageChangeFront(image: any): void;
  className: string;
}

export default class PostcardImageFrontEditorForm extends React.Component<IPostcardImageFrontEditorFormProps> {

  render() {
    return (
      <div className={this.props.className}>
        {this.props.postcardImagesList.filter(image => image.side === "Front").map((image, key) => (
          <div key={image.id} className="rowStepTwo">
            <Radio
              checked={(this.props.document.postcardImageFront && this.props.document.postcardImageFront.id === image.id)!}
              onChange={() => this.props.onPostcardImageChangeFront(image)}
            >
              <div className="image-box">
                <img alt={image.name} src={image.image_src} />
                <span>{image.name}</span>
              </div>
            </Radio>
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentEditor/PostcardImageFrontEditorForm.tsx